import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "importformat"
    }}>{`ImportFormat`}</h1>
    <p>{`Style import options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHARACTER_STYLES_FORMAT`}</strong>{` = 1131565940`}</p>
      <p parentName="blockquote">{`Imports character styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PARAGRAPH_STYLES_FORMAT`}</strong>{` = 1885885300`}</p>
      <p parentName="blockquote">{`Imports paragraph styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_STYLES_FORMAT`}</strong>{` = 1668305780`}</p>
      <p parentName="blockquote">{`Imports character and paragraph styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOC_STYLES_FORMAT`}</strong>{` = 1415795572`}</p>
      <p parentName="blockquote">{`Imports table of contents styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OBJECT_STYLES_FORMAT`}</strong>{` = 1332368244`}</p>
      <p parentName="blockquote">{`Imports object styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STROKE_STYLES_FORMAT`}</strong>{` = 1817408620`}</p>
      <p parentName="blockquote">{`Imports stroke styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TABLE_STYLES_FORMAT`}</strong>{` = 1700033396`}</p>
      <p parentName="blockquote">{`Imports table styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CELL_STYLES_FORMAT`}</strong>{` = 1698919284`}</p>
      <p parentName="blockquote">{`Imports cell styles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TABLE_AND_CELL_STYLES_FORMAT`}</strong>{` = 1700021107`}</p>
      <p parentName="blockquote">{`Imports table and cell styles.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      